/**
 * Returns a status string based on the provided boolean value.
 * @param status - A boolean or null value to determine the status.
 * @returns A string representing the status: "Active", "Deactive", or "In Progress".
 */
export function getStatusDisplayName(status: string): string {
  const statusMap: { [key: string]: string } = {
    APPROVAL_REQUIRED: 'Pending',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
  };
  return statusMap[String(status)] || '';
}
